import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '../../components/ui/Button';
import { OptionsProps, Option } from '../../types';

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 2.4rem;
`;

const Options: React.FC<OptionsProps> = ({ question, onNewAnswer, answer }) => {
  // State to store the randomized options
  const [randomizedOptions, setRandomizedOptions] = useState<{ option: Option; originalIndex: number }[]>([]);

  // Function to shuffle an array (Fisher-Yates algorithm)
  const shuffleArray = <T extends unknown>(array: T[]): T[] => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  // Randomize options when the question changes
  useEffect(() => {
    const optionsWithIndices = question.options.map((option, index) => ({
      option,
      originalIndex: index
    }));

    setRandomizedOptions(shuffleArray(optionsWithIndices));
  }, [question]);

  return (
    <OptionsContainer>
      {randomizedOptions.map(({ option, originalIndex }) => (
        <Button
          key={originalIndex}
          $option
          onClick={() => onNewAnswer(originalIndex)}
          className={`
            ${originalIndex === answer ? 'answer selected' : ''}
          `}
        >
          {option.answer}
        </Button>
      ))}
    </OptionsContainer>
  );
};

export default Options;
